import { ObservableArray, View } from "binder"
import { AttachmentListSelectorViewModel, attachmentViewModel } from "./attachmentListSelector-viewModel"

export class AttachmentListSelectorView extends View<AttachmentListSelectorViewModel>{
    GetViewUniqueId(): string {
        return "V-43F7039F-400A-4CE1-9BAB-D98C2CDAD24D"
    }
    loadHtml(): string {
        let element = require('./attachmentListSelector.html').default;
        let style = require('./attachmentListSelector.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set isReadonly(v: boolean) { this._isReadonly = v; } public get isReadonly(): boolean { return this._isReadonly;} private _isReadonly: boolean;
    public set attachments(v: ObservableArray<attachmentViewModel>) { this._attachments = v; } public get attachments(): ObservableArray<attachmentViewModel> { return this._attachments;} private _attachments: ObservableArray<attachmentViewModel>;
    
    addNewAttachment(){
        this.dataContext.addNewAttachment();
    }
}
